import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailAttachmentsComponent } from './email-attachments/email-attachments.component';
import { EmailEmbedsComponent } from './email-embeds/email-embeds.component';
import { EmailSettings } from './email-settings.types';
import { HeaderComponent } from './header/email-settings-header.component';

@Component({
  standalone: true,
  imports: [CommonModule, EmailEmbedsComponent, EmailAttachmentsComponent, HeaderComponent],
  selector: 'mode-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailSettingsComponent {
  @Input({ required: true }) selections!: EmailSettings;
  @Input() disableEmailAttachments = false;
  @Input() testEmail?: string;

  @Output() selectionsChanged = new EventEmitter<EmailSettings>();
  @Output() sendTestEmail = new EventEmitter<void>();

  public updateEmailSettings(newSettings: Partial<EmailSettings>) {
    this.selectionsChanged.emit({
      ...this.selections,
      ...newSettings,
    });
  }
}
